// angular.module('HeroPRO').directive('inputTypeGenerator',


export default function InputTypeGeneratorDirective($compile, $rootScope) {
    return {
        restrict: 'E',
        scope: {
            objectSource: '=',
            formSource: '=',
            last: '=',
        },
        link(scope, element) {
            // this is very specific to min/max, would be better to have a general format handler
            function setupMinMaxInputTypeFormatProperties(format) {
                const formatProperties = {};

                formatProperties.minMaxParts = format;

                for (let i = 0; i < formatProperties.minMaxParts.length; i++) {
                    const parts = formatProperties.minMaxParts[i];
                    const name = parts.Name;
                    const value = parts.Value;

                    switch (name) {
                    case 'min':
                        formatProperties.min = parseFloat(value);
                        break;
                    case 'max':
                        formatProperties.max = parseFloat(value);
                        break;
                    case 'format':
                        formatProperties.format = value;
                        break;
                    }
                }


                return formatProperties;
            }


            scope.getFormatProperties = function (format) {
                // we only have one type currently, possible in the future there will be others...
                return setupMinMaxInputTypeFormatProperties(format);
            };

            scope.inputChanged = function () {
                $rootScope.$broadcast('inputTypesDirective.MFAFormChanged');
            };

            // <hp-input-types object-source="inputGroup" form-source="model.mfaForm" last="$last"></hp-input-types>

            const directiveName = `hp-input-type-${scope.objectSource.TypeId}`;
            const generatedTemplate = `<${directiveName}></${directiveName}>`;
            element.append($compile(generatedTemplate)(scope));
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productdetail/inputTypes/inputTypeGenerator.directive.js